export const QUERY_KEYS = {
  holdsAndCheckoutsPage: 'holdsAndCheckoutsPage',
  projects: 'projects',
  projectDetails: 'projectDetails',
  userItemStatuses: 'userItemStatuses',
  savedInstancesCompact: 'savedInstancesCompact',
};

export interface PlaceHoldDto {
  requestId: string;
  item: {
    instanceId: string;
    itemId: string;
    title: string;
  };
  requestDate: string;
  status: string;
  pickupLocationId: string;
  queuePosition: number;
}

export interface HoldActionErrorDto {
  response: {
    data:
      | string
      | {
          errorMessage: string;
        };
  };
}
